import styled from 'styled-components';
import Colors from '../../../colors';

const SaleHomeTileStyles = styled.div``;

export default SaleHomeTileStyles;
